'use client';
import './App.css';
import { AuthProvider } from 'oidc-react';
import { store } from './lib/state/Store';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { token } from './lib/state/slices/AuthSlice';
import ResearchPage from './pages/ResearchPage/Index';
import ResourcePage from './pages/ResourcePage';
import GraphOverviewPage from './pages/GraphsOverviewPage/Index';
import AuthHandler from './lib/AuthHandler';
import GuidePage from './pages/GuidePage';
import LoadingScreen from './pages/LoadingScreen';
import AutoSaver from './lib/AutoSaver';
import LoadAppStateFromServer from './lib/LoadAppStateFromServer';
import { FolderPage } from './pages/FolderPage';
import FoldersOverviewPage from './pages/FoldersOverviewPage/Index';
import { Toaster } from './components/ui/toaster';
import Page from './layouts/SidebarLayout';
import { GraphPage } from './pages/GraphPage/Index';
import SettingsPage from './pages/SettingsPage';
import { ThemeSystemProvider } from './lib/ThemeSwitcher';
declare global {
  interface Window {
    _mtm?: any[];
  }
}

function App() {

  return (
    <div className="App">
      <ThemeSystemProvider>
        <AuthProvider
          authority={
            'https://auth.meshr.org/realms/' +
            (process.env.REACT_APP_AUTH_REALM
              ? process.env.REACT_APP_AUTH_REALM
              : 'no auth realm set')
          }
          clientId="frontend"
          redirectUri={
            process.env.REACT_APP_REDIRECT_URL
              ? process.env.REACT_APP_REDIRECT_URL
              : 'http://localhost:3000'
          }
          onSignIn={(user) => {
            // the `user` prop is actually the data the app received from `/userinfo` endpoint.
            store.dispatch(token(user!!.access_token));
          }}
          autoSignIn={true}
          automaticSilentRenew={true}
        >
          <Provider store={store}>
            <AuthHandler>
              <LoadAppStateFromServer />
              <AutoSaver />
              <Toaster />
              <BrowserRouter>
                <Page>
                  <Routes>
                    <Route path="/" element={<Navigate to={'/research'} />} />
                    <Route path="/research" element={<ResearchPage />} />
                    <Route path="/saved_cases" element={<FoldersOverviewPage />} />
                    <Route path="/saved_cases/:folderId" element={<FolderPage />} />
                    <Route path="/graphs" element={<GraphOverviewPage />} />
                    <Route path="/graphs/:graphId" element={<GraphPage />} />
                    <Route path="/resources" element={<ResourcePage />} />
                    <Route path="/resources/:resourceId" element={<ResourcePage />} />
                    <Route path="/learn_more/*" element={<GuidePage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                    <Route path="/loading" element={<LoadingScreen />} />
                  </Routes>
                </Page>
              </BrowserRouter>
            </AuthHandler>
          </Provider>
        </AuthProvider>
      </ThemeSystemProvider>
    </div>
  );
}

export default App;
